<template>
  <div class="form-field">
    <label class="" placeholder="{{ placeholder }}">
      <span>{{ label }}</span>
      <span v-if="required" class="form-required">*</span>
    </label>
    <div class="input">
      <input
        id="{{id}}"
        name="{{id}}"
        type="text"
        class="input"
        inputmode="text"
        autocomplete="{{autocomplete}}"
        style="
          background-repeat: no-repeat;
          background-attachment: scroll;
          background-size: 16px 18px;
          background-position: 98% 50%;
          cursor: pointer;
        "
        :value="value"
        @change="$emit('change', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "FormField",
  props: {
    placeholder: String,
    required: Boolean,
    id: String,
    autocomplete: String,
    label: String,
    value: String,
  },
};
</script>

<style scoped>
label {
  font-size: 12px;
  text-transform: uppercase;
  font-family: var(--body-font);
  font-weight: 400;
  line-height: 2;
  padding-bottom: 3px;
  display: block;
  letter-spacing: 0.05em;
  text-align: start;
}

input {
  font-size: 16px;
  border: 1px solid #ececec;
  font-family: Work Sans, serif;
  border-radius: 4px;
  padding: 8px 10px;
  width: 60%;
  line-height: 1.5;
  margin: 0;
  display: block;
  transition: border 0.15s, outline 0.15s;
  writing-mode: horizontal-tb !important;
  text-rendering: auto;
  color: fieldtext;
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 0;
  text-shadow: none;
  text-align: start;
  appearance: auto;
  -webkit-rtl-ordering: logical;
  background-color: #fff;
  border-image: initial;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-size: 16px 18px;
  background-position: 98% 50%;
  cursor: auto;
}

p {
  font-size: 13px;
  font-family: Work Sans, serif;
  font-weight: var(--normal);
  line-height: 1.2;
  padding-bottom: 0;
  margin-bottom: 14px;
}
</style>
